import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import $ from 'jquery';
import { Link } from 'react-router';
import AsyncImage from 'common/components/AsyncImage';
import OrderButtons from 'common/components/OrderButtons';

const AnswerImage = ({ answer }) => {
  let url, raw;
  if (answer && answer.image) {
    if (answer.image.id) {
      url = answer.image.web;
    } else {
      raw = answer.image;
    }
  }

  return (
    <AsyncImage
      src={url}
      raw={raw}
      className="ui small image"
      style={{ width: 'auto' }}
    />
  );
};

AnswerImage.propTypes = {
  answer: PropTypes.object.isRequired,
};

function renderImage(question, answer) {
  return question.template === 'image' ? (
    <AnswerImage answer={answer} />
  ) : (
    <div className="ui small image">
      <i className="align left icon" />
    </div>
  );
}

class AnswerItem extends React.Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    answer: PropTypes.object.isRequired,
    answerCount: PropTypes.number.isRequired,
    moveAnswerDown: PropTypes.func.isRequired,
    moveAnswerUp: PropTypes.func.isRequired,
    deleteAnswer: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.moveDown = this.moveDown.bind(this);
    this.moveUp = this.moveUp.bind(this);
    this.remove = this.remove.bind(this);
  }

  componentDidMount() {
    $(this.refs.dimmer).dimmer({
      on: 'hover',
    });
  }

  moveUp() {
    const { answer } = this.props;
    this.props.moveAnswerUp(answer);
  }

  moveDown() {
    const { answer } = this.props;
    this.props.moveAnswerDown(answer);
  }

  remove() {
    const { answer } = this.props;
    this.props.deleteAnswer(answer);
  }

  renderImage(question, answer) {
    return question.template === 'image' ? (
      <AnswerImage answer={answer} />
    ) : (
      <div className="ui small image">
        <i className="align left icon" />
      </div>
    );
  }

  render() {
    const { question, answer, answerCount } = this.props;

    return (
      <div className="item">
        {renderImage(question, answer)}
        <div className="middle aligned content">
          <div className="description" ref="dimmer">
            <div className="inner">{answer.content}</div>
            <div className="ui inverted dimmer">
              <div className="content">
                <div className="center">
                  <Link
                    to={`/answers/${answer.id}`}
                    className="ui right labeled icon button"
                  >
                    <i className="edit icon" />
                    Modifier
                  </Link>
                  <button
                    className="ui right labeled icon button negative"
                    onClick={this.remove}
                  >
                    <i className="trash outline outline icon" />
                    Supprimer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ui small action">
          <OrderButtons
            canMoveDown={answer.order < answerCount}
            moveDown={this.moveDown}
            canMoveUp={answer.order > 1}
            moveUp={this.moveUp}
          />
        </div>
      </div>
    );
  }
}

export default pure(AnswerItem);



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/questions/AnswerItem.js